import { render } from "./HandSignatureTabletFormComponentDetails.vue?vue&type=template&id=59d03a9a"
import script from "./HandSignatureTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./HandSignatureTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__